export const NAVBAR_OFFSET = -65;
export const SECTION_PADDING = 32;
